import { render, staticRenderFns } from "./UserPermissionTable.vue?vue&type=template&id=f2eff592&scoped=true&"
import script from "./UserPermissionTable.vue?vue&type=script&lang=js&"
export * from "./UserPermissionTable.vue?vue&type=script&lang=js&"
import style0 from "./UserPermissionTable.vue?vue&type=style&index=0&id=f2eff592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2eff592",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
